import EXTERNAL_DEVICE from './ExternalDevice';

const { POE_SWITCH, NETWORK_SPEAKER } = EXTERNAL_DEVICE.TYPE;

const DEVICE_TYPE = Object.freeze({
  CAMERA: 'camera',
  NVR: 'nvr',
  NVR_CHANNEL: 'nvrchannel',
  VSS: 'vss',
  VSS_CHANNEL: 'vsschannel',
  BRIDGE: 'bridge',
  POE_SWITCH,
  NETWORK_SPEAKER,
  UNKNOWN_DEVICE: 'unknownDevice',
  MA: 'ma',
  MA_CHANNEL: 'machannel',
});

const DEVICE_TRACKING_TYPE_MAP = Object.freeze({
  [DEVICE_TYPE.CAMERA]: DEVICE_TYPE.CAMERA,
  [DEVICE_TYPE.NVR]: DEVICE_TYPE.NVR,
  [DEVICE_TYPE.NVR_CHANNEL]: 'nvrChannel',
  [DEVICE_TYPE.VSS]: DEVICE_TYPE.VSS,
  [DEVICE_TYPE.VSS_CHANNEL]: 'vssChannel',
  [DEVICE_TYPE.BRIDGE]: DEVICE_TYPE.BRIDGE,
  [DEVICE_TYPE.POE_SWITCH]: DEVICE_TYPE.POE_SWITCH,
  [DEVICE_TYPE.NETWORK_SPEAKER]: DEVICE_TYPE.NETWORK_SPEAKER,
  [DEVICE_TYPE.UNKNOWN_DEVICE]: 'unknown',
  [DEVICE_TYPE.MA]: DEVICE_TYPE.CAMERA,
  [DEVICE_TYPE.MA_CHANNEL]: DEVICE_TYPE.CAMERA,
});

const DEVICE_SUPPORT_FEATURES = Object.freeze({
  REMOTE_FOCUS: 'remotefocus',
  PRIVACY_MASK: 'privacy-mask',
  AUDIO_IN: 'audioin',
  RTSP_ACCESS: 'rtsp-access',
  TAMPERING: 'tampering',
  TAMPERING_SMART: 'tampering-smart',
  DIGITAL_INPUT: 'di',
  DIGITAL_OUTPUT: 'do',
  DAY_NIGHT: 'daynight',
  PTZV2: 'ptzv2',
  PTZV3: 'ptzv3',
  AUDIO_CLIP: 'audioclip',
  WEBHOOK: 'webhook-v2',
  VIDEO_STREAM: 'videoin_stream3',
  TIMELAPSE: 'timelapse',
  RETENTION_DAYS_BY_USER: 'retentionDaysByUser',
  CHANNEL_FIRMWARE_UPGRADE: 'channelfirmwareupgrade',
  API_WITH_CHANNEL: 'apiWithChannel',
});

const ADD_DEVICE_INSPECT_TYPE = Object.freeze({
  VSS: DEVICE_TYPE.VSS,
  UNKNOWN: DEVICE_TYPE.UNKNOWN_DEVICE,
});

const ADD_DEVICE_INSPECT_STATUS = Object.freeze({
  ACTIVE: 'ACTIVE',
  ADDED: 'ADDED',
});

const ADD_DEVICE_MENU_TYPE = Object.freeze({
  DEFAULT_DEVICE: 'DefaultDevice',
  POE_SWITCH,
  NETWORK_SPEAKER,
});

const ADD_DEVICE_MENU_LABEL = Object.freeze({
  [ADD_DEVICE_MENU_TYPE.DEFAULT_DEVICE]: (t, allowVssPrompt) => (allowVssPrompt ? `${t('Camera, NVR, Bridge, VSS')}` : t('Camera, NVR, Bridge device')),
  [ADD_DEVICE_MENU_TYPE.POE_SWITCH]: (t) => `${t('PoE Switch')}`,
  [ADD_DEVICE_MENU_TYPE.NETWORK_SPEAKER]: (t) => `${t('Network Speaker')}`,
});

const ADD_DEVICE_API_ERROR_KEYWORDS = Object.freeze({
  ALREADY_ADDED: 'already added',
  INVALID_MAC: 'invalid mac',
  REACHED_LIMIT: 'reached limit',
  ONLY_SUPPORT_FREE_PLAN: 'only support free plan for this device type',
  ORG_HAS_VSS: 'org has vss'
});

const ADD_DEVICE_ERROR_MESSAGES = Object.freeze({
  [ADD_DEVICE_API_ERROR_KEYWORDS.ALREADY_ADDED]: (t) => t('Device can not be added twice.'),
  [ADD_DEVICE_API_ERROR_KEYWORDS.INVALID_MAC]: (t) => t('Invalid Device ID'),
  [ADD_DEVICE_API_ERROR_KEYWORDS.REACHED_LIMIT]: (t) => t('Maximum 1000 devices are reached in an organization.'),
  [ADD_DEVICE_API_ERROR_KEYWORDS.ONLY_SUPPORT_FREE_PLAN]: (t, isMarchNetworks = false) => (isMarchNetworks
    ? t('VSS is not supported on xPro plans.')
    : t('VSS is not supported on xStd or xPro plans.')),
  [ADD_DEVICE_API_ERROR_KEYWORDS.ORG_HAS_VSS]: (t, isMarchNetworks = false) => (isMarchNetworks
    ? t('VSS is not supported on xPro plans. Please delete VSS to continue the upgrade.')
    : t('VSS is not supported on xStd or xPro plans. Please delete VSS to continue the upgrade.')),
  DEFAULT: (t) => t('Failed to connect to server.'),
});

export {
  DEVICE_TYPE,
  DEVICE_TRACKING_TYPE_MAP,
  DEVICE_SUPPORT_FEATURES,
  ADD_DEVICE_MENU_TYPE,
  ADD_DEVICE_MENU_LABEL,
  ADD_DEVICE_INSPECT_TYPE,
  ADD_DEVICE_INSPECT_STATUS,
  ADD_DEVICE_API_ERROR_KEYWORDS,
  ADD_DEVICE_ERROR_MESSAGES
};
